const GST_TIMEZONE = 'Asia/Dubai';

/**
 * Get the current date & time in GST formatted for `datetime-local`
 */
export const getCurrentGSTDateTime = (): string => {
  const now = new Date();

  // Convert to GST using Intl.DateTimeFormat
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: GST_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(now);
  return `${parts[4].value}-${parts[2].value}-${parts[0].value}T${parts[6].value}:${parts[8].value}`;
};

export const convertUTCToGST = (utcDate: string): string => {
  if (utcDate.length === 0) return '';
  const date = new Date(utcDate);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: GST_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  return `${parts[4].value}-${parts[2].value}-${parts[0].value}T${parts[6].value}:${parts[8].value}`;
};
